export const WORKFLOW_ID = 'HomePurchaseWorkflow';
export const ANALYTICS_ID = 'home_purchase_workflow';
export const BACKEND_KEY = 'HomePurchaseGoal';
export const HOME_PURCHASE_GOAL_GRAPH_NODE = 'HomePurchaseGoal';
